import axios from "axios"
import qs from "qs";

export function ajax(params = {}, callback) {
    const ajaxURL = process.env.NODE_ENV === 'development'
        ? 'http://dev.dengoo.kz/wp-admin/admin-ajax.php'
        : '/wp-admin/admin-ajax.php';

    try {
        axios.post(
            ajaxURL,
            qs.stringify(params),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            }
        ).then(response => {
            if (callback) {
                callback(response.data);
            }
        }).catch(error => {
            if (callback) callback(null, error);
        });
    } catch (error) {
        if (callback) callback(null, error);
    }
}

export function reachTarget (target, counter){
    console.table(target, counter)
    if(target && counter){
        if(counter === 'metrika' && typeof ym !== 'undefined') {
            ym(counters.metrika, 'reachGoal', target)
            console.log("reach " + counter + " target " + target)
        }
        if(counter === 'analytics' && typeof gtag !== 'undefined') {
            gtag('event', 'Переход', {
                'event_category': 'click',
                'event_action': target
            });
            console.log("reach " + counter + " target " + target)
        }
        if(counter === 'mytarget' && typeof _tmr !== 'undefined') {
            _tmr.push({
                id: counters.mytarget,
                type: 'reachGoal',
                goal: target
            });
            console.log("reach " + counter + " target " + target)
        }
        if(counter === 'facebook' && typeof fbq !== 'undefined') {
            fbq('track', target);
            console.log("reach " + counter + " target " + target)
        }
    }
}


// Добавление событий по селектору
export function addEventListener(eventType, selector, handler) {
    document.addEventListener(eventType, function (event) {
        if (event.target.matches(selector)) {
            handler.call(event.target, event, event.target);
        } else {
            let matchingAncestors = event.target.closest(selector);
            if (matchingAncestors) {
                handler.call(matchingAncestors, event, matchingAncestors);
            }
        }
    });
}

export function each(selector, callback) {
    let collection = document.querySelectorAll(selector)
    for (let i = 0; i < collection.length; i++) {
        callback.call(collection[i], collection[i], i)
    }
}
export function hasClass(element, className) {
    element = getTargetElement(element)
    return element && element.classList.contains(className);
}

export function removeClass(element, className) {
    element = getTargetElement(element)
    if(!hasClass(element, className) ) return
    if (element) element.classList.remove(className);
}

export function addClass(element, className) {
    element = getTargetElement(element)
    if (element) element.classList.add(className);
}

export function toggleClass(element, className) {
    if (element.classList.contains(className)) {
        element.classList.remove(className);
    } else {
        element.classList.add(className);
    }
}

export function after(elementToInsert, targetElement) {
    let parent = targetElement.parentNode;
    if (parent.lastChild === targetElement) {
        parent.appendChild(elementToInsert);
    } else {
        parent.insertBefore(elementToInsert, targetElement.nextSibling);
    }
}
export function next(element) {
    return element.nextElementSibling;
}
export function prev(element) {
    let previousElement = element.previousElementSibling;
    while (previousElement && previousElement.nodeType !== 1) {
        previousElement = previousElement.previousElementSibling;
    }
    return previousElement;
}
export function parent(element, selector) {
    let parentElement = element.parentNode;
    if (!selector) return parentElement;

    while (parentElement) {
        if (parentElement.matches(selector)) {
            return parentElement;
        }
        parentElement = parentElement.parentNode;
    }
    return null;
}

export function find(parentElement, selector) {
    return parentElement.querySelectorAll(selector)
}

export function elementExists(selector, callback) {
    if (selector instanceof HTMLElement) return selector
    const elements = document.querySelectorAll(selector)
    if (elements.length > 0 && callback) {
        callback(elements)
        return true
    }
    return false
}


export function attr(element, attributeName, value) {
    if (value === undefined) {
        return element.getAttribute(attributeName);
    } else {
        element.setAttribute(attributeName, value);
    }
}

export function data(element, key, value) {

    // Если element - строка, то предполагаем, что это селектор, и получаем элемент
    if (typeof element === 'string') {
        element = document.querySelector(element);
    }

    if (!element) return;

    if (value === undefined) {
        // Получение значения данных
        return element.dataset[key];
    } else {
        // Установка значения данных
        element.dataset[key] = value;
    }
}

export function closest(element, selector) {
    while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
            return element;
        }
        element = element.parentNode;
    }
    return null;
}

export function index(element, className, increment = false) {
    const parent = element.parentNode;
    const children = parent.children;
    const filteredChildren = Array.from(children).filter(function (child) {
        return child.classList.contains(className);
    });

    for (var i = 0; i < filteredChildren.length; i++) {
        if (filteredChildren[i] === element) {
            return (increment ? i + 1 : i);
        }
    }

    return -1;
}

export function slideUp (target, duration=500) {
    target = getTargetElement(target)
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
    }, duration);
}

export function slideDown (target, duration=500) {
    target = getTargetElement(target)
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
        target.style.removeProperty('height');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
    }, duration);
}

export function slideToggle (target, duration = 500) {
    target = getTargetElement(target)
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
}

export function getTargetElement(target) {
    if (typeof target === 'string') {
        const elements = document.querySelectorAll(target);
        if (elements.length === 0) return;
        return elements[0];
    }
    return target;
}

export function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null; // Cookie не найдено
}

export function getAllCookies() {
    let cookiesString = document.cookie;
    let cookiesArray = cookiesString.split('; ');
    let cookiesObject = {};
    cookiesArray.forEach(function(cookie) {
        let cookieParts = cookie.split('=');
        let cookieName = cookieParts[0];
        let cookieValue = cookieParts[1];
        cookiesObject[cookieName] = decodeURIComponent(cookieValue);
    });
    return cookiesObject;
}

export function createLabel (number, titles){
    const cases = [2, 0, 1, 1, 1, 2];
    return `${titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]}`;
}

export function deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

export function isDefinedAndNotEmpty(variable) {
    return variable !== undefined && variable !== null && variable !== '';
}

export function isInViewport(element) {
    if(!elementExists(element)) return
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}